export const ALL_INVOICES_REQUEST = "ALL_INVOICES_REQUEST";
export const ALL_INVOICES_SUCCESS = "ALL_INVOICES_SUCCESS";
export const ALL_INVOICES_FAIL = "ALL_INVOICES_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";